import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Alert } from '@zooplus/ui-components';
import BaseModal from '../BaseModal/BaseModal.js';
import styles from '../BaseModal/BaseModal.module.scss.js';
import { useTranslation } from '../../../../hooks/useTranslations.js';
import { useCreditcardService } from '../../../../providers/CreditCardsMutationProvider.js';
import { useOverlays, OverlayIds } from '../../../../providers/OverlaysProvider.js';
import { captureException } from '../../../../services/sentryService.js';

/**
 * Modal to make the customer confirms that he really wants to delete all his stored credit cards.
 * Independent from the actual payment service provider.
 */
const DeleteAllCardsModal = () => {
    const { t } = useTranslation();
    const { deleteAllCards } = useCreditcardService();
    const { hideOverlay } = useOverlays();
    const [deleteAllLoading, setDeleteAllLoading] = useState(false);
    const [deleteAllError, setDeleteAllError] = useState();
    const handleDeleteAllConfirm = () => {
        setDeleteAllLoading(true);
        setDeleteAllError(undefined);
        deleteAllCards()
            .then(() => {
            // zpp-api does not return a boolean on the deleteAllCards endpoint.
            // When the response is deserialized in shop-checkout, it defaults to false and returns it to payment-frontend.
            // So we are always displaying an error, even though all cards have been deleted.
            // This is disabled until the situation is fixed.
            // if (isSuccess) {
            hideOverlay(OverlayIds.DELETE_ALL_CARDS);
            // } else {
            //   setDeleteAllError(t('checkout.payment.creditcard.error.deleteallcards.apicall'));
            // }
            setDeleteAllLoading(false);
        })
            .catch((error) => {
            // on any unexpected error, send it to Sentry and display a generic error message to the user
            captureException({ error });
            setDeleteAllError(t('checkout.payment.creditcard.error.deleteallcards.apicall'));
            setDeleteAllLoading(false);
        });
    };
    return (jsxs(BaseModal, { modalId: OverlayIds.DELETE_ALL_CARDS, disabledPrimaryBtn: deleteAllLoading, disabledSecondaryBtn: deleteAllLoading, isLoading: deleteAllLoading, handleSubmit: handleDeleteAllConfirm, heading: t('checkout.payment.creditcard.delete'), primaryButtonLabel: t('general.button.delete'), headingId: "delete-all-cards", size: "sm", closeBtnAriaLabel: t('checkout.payment.creditcard.delete'), dataZta: "modal-removeAllCards", children: [deleteAllError && (jsx(Alert, { className: styles.errorMessage, variant: "warning", children: deleteAllError })), jsx("div", { className: styles.confirmDeleteMessage, children: t('checkout.payment.creditcard.deleteAll.confirm') })] }));
};

export { DeleteAllCardsModal as default };
//# sourceMappingURL=DeleteAllCardsModal.js.map
